import * as network from '../../pixelstreaming/network';
import { CanvasInfo } from '../base';
import * as marietta from '../..';

class PixelStreamingView implements network.imageReceiver {
  private canvas: HTMLCanvasElement;

  private data: string | null = null;

  container : HTMLElement | null = null;

  private counter: number = 0;

  // create canvas
  constructor(container) {
    this.container = container;

    this.createCanvas();
  }

  private createCanvas() {
    this.canvas = document.createElement('canvas');
    this.canvas.setAttribute('id', 'pixelStreamingView');
    this.canvas.style.cursor = 'pointer';
    this.canvas.style.pointerEvents = 'none';
    this.canvas.style.backgroundColor = '#EEEEEE';
    this.canvas.style.position = 'absolute';
    this.canvas.style.display = 'none';
    this.showHideCanvas(false);
    this.container.prepend(this.canvas);
    const { size } = CanvasInfo.get();
    this.canvas.width = size.width;
    this.canvas.height = size.height;
  }

  public onChange(status): void {
    if (status == network.statustype.connect) {
    //   this.createCanvas();
        this.clearCanvas();
    }
    if (status == network.statustype.disconnect) {
    //   ThreeView.get().renderer.canvasSizeChanged();
        this.showHideCanvas(false);
        this.counter = 0;
        marietta.webcad.WebCADGlobal.hideBusy();
    }
  }

  public onSend(json: string): void {
    ;
  }

  private downloadImage(image) {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext("2d").drawImage(image, 0, 0);

        const blob = canvas.toDataURL("image/jpeg");

        const a = document.createElement("a");
        a.href = blob;
        a.download = "WebCADRendering.jpg";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
  }

  private clearCanvas() {
    const context = this.canvas.getContext('2d');
    context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  // load image into canvas
  public onImage(data: string): void {
    this.counter++;
    this.data = data;
    console.log("pw2222")
    const context = this.canvas.getContext('2d');
    const image = new Image();
    image.onload = () => {
        const height = image.naturalHeight;
        const width = image.naturalWidth;
        const hRatio = this.canvas.width / width;
        const vRatio = this.canvas.height / height;
        const ratio = Math.min(hRatio, vRatio);
        context.clearRect(0, 0,  width * ratio, height * ratio);
        context.drawImage(image, 0, 0, width, height, 0, 0, width * ratio, height * ratio);
        console.log(`JPEG Format : Image Size : ${width} x ${height}`);
        if (this.counter == 2) {
            this.downloadImage(image);
            this.counter = 0;
            marietta.webcad.WebCADGlobal.hideBusy();
            this.showHideCanvas(false);
            this.clearCanvas();
        }
    };
    image.src = data;
  }

  // show/hide canvas
  public showHideCanvas(show: boolean = true) {
    if(document.getElementById('pixelStreamingView')) document.getElementById('pixelStreamingView').style.display = show ? 'block' : 'none';
  }

  public updateCanvasSize(newSize=null) {
    const { size } = CanvasInfo.get();
    this.canvas.width = size.width;
    this.canvas.height = size.height;
    if(this.data) this.onImage(this.data);
    return;
  }
}
export default PixelStreamingView;
